module.exports = __webpack_public_path__ + "static/opener-text-6ed59cefa7f1d6f20d4f90a2e8998a76.png";